<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="finalVisible"
    title="关闭订单"
    width="40%">
    <div>
      <!-- 关闭原因选择框 -->
      <el-form :model="form" label-position="left" label-width="160px">
        <el-form-item :rules="[{ required: true, message: '请选择关闭理由', trigger: 'blur' }]"
                      label="关闭理由"
        >
          <el-select v-model="form.closeReason" placeholder="请选择关闭理由" style="width: 100%;"
                     @change="onReasonChange">
            <el-option
              v-for="(reason, index) in reasonOptions"
              :key="index"
              :label="reason.label"
              :value="reason.value"
            />
          </el-select>
        </el-form-item>

        <!-- 如果选择了“其他”，显示输入框 -->
        <el-form-item v-if="form.closeReason === 'other'"
                      :rules="[{ required: true, message: '请输入关闭理由', trigger: 'blur' }]"
                      label="关闭理由">
          <el-input
            v-model="form.customReason"
            placeholder="请输入关闭理由"
            rows="2"
            type="textarea"
          />
        </el-form-item>

        <!-- 推送用户文案输入框 -->
        <el-form-item v-if="isOrdered !== 1" :rules="[{ required: true, message: '请输入推送给用户的消息', trigger: 'blur' }]"
                      label="推送给用户的消息"
        >
          <el-input
            v-model="form.userMessage"
            placeholder="请输入推送给用户的消息"
            rows="3"
            type="textarea"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button style="margin-right: 10px;" @click="closeDialog">取消</el-button>

      <!-- 确认按钮加上 popover -->
      <el-popover
        v-model:visible="confirmVisible"
        placement="top"
        width="200">
        <p>确定要关闭此订单吗？</p>
        <div style="text-align: right; margin: 10px 0 0 0;">
          <el-button size="mini" @click="confirmVisible = false">取消</el-button>
          <el-button
            :loading="loading"
            size="mini"
            type="primary"
            @click="confirmCloseOrder">确认
          </el-button>
        </div>
        <el-button slot="reference" type="primary">确认</el-button>
      </el-popover>
    </div>
  </el-dialog>
</template>

<script>
import mini from '@/api/mini';
import {number} from "echarts/lib/export"; // 引入 MiniModel

const MiniModel = new mini();

export default {
  name: 'TaobaoOrderErrorCloseDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    isOrdered: {
      type: Number,
      required: false
    }
  },
  computed: {
    finalVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    // form.closeReason 改变时，confirmVisible 置为 false
    'form.closeReason': function () {
      this.confirmVisible = false;
    },
    'form.userMessage': function () {
      this.confirmVisible = false;
    },
    'form.customReason': function () {
      this.confirmVisible = false;
    },
    isOrdered:{
      handler(newVal, oldVal) {
        // 响应变化
        if(newVal === 1) {
          // 把reasonOptions中value是other的元素删除
          this.reasonOptions = this.reasonOptions.filter(item => item.value !== 'other')
        }else{
          // 把reasonOptions中value是other的元素删除
          this.reasonOptions = this.reasonOptions.filter(item => item.value !== 'other')
          // 把reasonOptions中value是other的元素添加到reasonOptions中
          this.reasonOptions.push({value: 'other', label: '其他', message: ''})
        }
      },
      deep: true, // 启用深度监听
      immediate: true // 可选：立即触发一次
    },
  },
  data() {
    return {
      form: {
        closeReason: '',
        customReason: '',
        userMessage: ''
      },
      loading: false,  // 加载状态
      confirmVisible: false,  // 控制 popover 显示状态
      reasonOptions: [
        /**
         * 座位已被占
         *
         *
         * 亲亲，您购买的座位已被占，请重新选座！
         *
         *
         * 未找到排期
         *
         *
         * 亲亲，非常抱歉，平台暂无法查询到您所需购买的影票信息！请您选择其他影院或场次下单哦！
         *
         *
         * 临场已无法下单
         *
         *
         * 亲亲，您所需购买的影票，离开场已不足30分钟，平台已无法下单出票！请您选择其他影院或场次下单哦！
         *
         *
         * 平台报价无优惠
         *
         *
         * 亲亲，您所需购买的影票平台暂无优惠哦！您可以选择其他影院或场次的影票下单！
         */
        {value: 'seat_occupied', label: '座位已被占', message: '亲亲，您购买的座位已被占，请重新选座！'},
        {
          value: 'no_tickets_found',
          label: '未找到排期',
          message: '亲亲，非常抱歉，平台暂无法查询到您所需购买的影票信息！请您选择其他影院或场次下单哦！'
        },
        {
          value: 'unable_to_order',
          label: '临场已无法下单',
          message: '亲亲，您所需购买的影票，离开场已不足30分钟，平台已无法下单出票！请您选择其他影院或场次下单哦！'
        },
        {
          value: 'platform_no_discount',
          label: '平台报价无优惠',
          message: '亲亲，您所需购买的影票平台暂无优惠哦！您可以选择其他影院或场次的影票下单！'
        },
        {value: 'other', label: '其他', message: ''}
      ]
    };
  },
  methods: {
    onReasonChange(selectedReason) {
      const selectedOption = this.reasonOptions.find(option => option.value === selectedReason);
      this.form.userMessage = selectedOption ? selectedOption.message : '';
      if (selectedReason !== 'other') {
        this.form.customReason = '';
      }
    },
    closeDialog() {
      this.$emit('update:visible', false);
      this.form.closeReason = '';
      this.form.customReason = '';
      this.form.userMessage = '';
    },
    async confirmCloseOrder() {
      if (!this.form.closeReason) {
        this.$message.error('请选择关闭理由');
        return;
      }
      if (this.form.closeReason === 'other' && !this.form.customReason) {
        this.$message.error('请输入自定义关闭理由');
        return;
      }

      const closeReasonLabel = this.reasonOptions.find(option => option.value === this.form.closeReason).label;
      const closeRemark = this.form.closeReason === 'other' ? this.form.customReason : closeReasonLabel;

      const data = {
        id: this.id,
        closeRemark,
        pushContent: this.form.userMessage
      };

      try {
        this.loading = true;  // 开始加载状态
        const response = await MiniModel.taobaoOcrCloseOrder(data);
        if (response.data && response.data.code === 200) {
          this.$message.success('订单关闭成功');
          this.$emit('close-success', data);
          this.closeDialog();
        } else {
          this.$message.error(response.data.message || '关闭订单失败');
        }
      } catch (error) {
        this.$message.error('请求失败，请重试');
      } finally {
        this.loading = false;  // 结束加载状态
        this.confirmVisible = false; // 关闭 popover
      }
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/components/taobaoOrderErrorCloseDialog.vue